<template>
  <form
    v-if="!isValidObject(data)"
    class="login__form form--custom"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <h2
      v-if="data.companyName"
      v-html="$t(`${namespace}.title`).replace('[VAL]', data.companyName)"
      class="login__title"
    />

    <p v-html="$t(`${namespace}.text`)" class="login__text" />

    <div>
      <FormTextField
        v-model="form.name"
        :label="$t(`${namespace}.fieldEmployeeLabel`)"
        :placeholder="$t(`${namespace}.fieldEmployeePlaceholder`)"
        :disabled="submitted"
        :name="$t(`${namespace}.fieldEmployeeName`)"
        :v-validate="{ required: true }"
      />

      <FormTextField
        v-model="form.phoneNumber"
        type="tel"
        :label="$t(`${namespace}.fieldCellNumberLabel`)"
        :placeholder="$t(`${namespace}.fieldCellNumberPlaceholder`)"
        :disabled="submitted"
        :name="$t(`${namespace}.fieldCellNumberName`)"
        mask="(##) #####-####"
        maxlength="15"
        :v-validate="{
          required: true,
          min: 15,
          max: 15
        }"
      />

      <FormTextField
        v-model="form.document"
        type="tel"
        :label="$t(`${namespace}.fieldDocumentLabel`)"
        :placeholder="$t(`${namespace}.fieldDocumentPlaceholder`)"
        :disabled="submitted"
        :name="$t(`${namespace}.fieldDocumentName`)"
        mask="###.###.###-##"
        :v-validate="{ cpf: true }"
      />
    </div>

    <v-layout align-center justify-center fill-height>
      <a @click.prevent="redirectToLogin">
        {{ $t('Common.cancel') }}
      </a>

      <v-spacer />

      <Button
        type="submit"
        color="secondary"
        gradient
        :disabled="submitted"
        :loading="submitted"
        large
      >
        {{ $t(`${namespace}.buttonLabel`) }}
      </Button>
    </v-layout>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { mask } from 'vue-the-mask'
import { isValidObject, catchError, removeNonNumbersChars } from 'corp-front-vue-commons/src/utils/functions'
import formValidator from 'mixins/formValidator'

export default {
  name: 'Form',
  mixins: [formValidator],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  directives: { mask },
  computed: {
    routeParams () {
      const { employeeId = null, token = null } = this.$route.params
      const id = employeeId ? Number(employeeId) : null
      return {
        employeeId: id,
        token
      }
    }
  },
  data () {
    return {
      namespace: 'Views.FirstAccessPage.form',
      submitted: false,
      form: {
        name: null,
        phoneNumber: null,
        document: null
      }
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    redirectToLogin () {
      this.$router.push({ name: 'Login' }).catch(e => {})
    },

    isValidObject (val) {
      return isValidObject(val)
    },

    setData () {
      if (this.isValidObject(this.data)) {
        const { name = null, companyName = null } = this.data

        this.form = {
          name,
          companyName
        }
      }
    },

    setSubmittedValue (boolean = true) {
      this.submitted = boolean
    },

    async handleSubmit () {
      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          this.setSubmittedValue(true)

          const { employeeId, token: firstAccessToken } = this.routeParams
          const { name, phoneNumber, document } = this.form
          const data = {
            name,
            phoneNumber: removeNonNumbersChars(phoneNumber),
            document: removeNonNumbersChars(document)
          }

          const { data: res } = await this.$apiService.employee.setEmployeeDataFirstAccess(employeeId, {
            ...data,
            firstAccessToken
          })

          if (!res || res.status !== 'success') {
            throw new Error()
          }

          this.$emit('toogleContainer', data)
        }
      } catch (error) {
        catchError(error)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.errorAlert`)
        })
      }

      this.setSubmittedValue(false)
    }
  },
  mounted () {
    this.setData()
  }
}
</script>
